import { createGroup, createRouter } from "@swan-io/chicane";

export type AccessibleRoute = Exclude<
  keyof typeof router,
  "replace" | "push" | "getRoute" | "useRoute"
>;
export type RouteName = Parameters<typeof router.getRoute>[0][number];
export type RouteArea = Exclude<RouteName, AccessibleRoute>;

export const router = createRouter({
  Index: "/",
  ...createGroup("Signin", "/signin?:from_app&:redirect_to", {
    Area: "*",
    Index: "/",
    Verification: "/verification?:email&:otp",
    SsoCallback: "/sso-callback",
  }),
  Signout: "/signout",
  UserOnboarding: "/onboarding?:create_org&:redirect_to",
  MyProfile: "/profile?:from_app",
  Invitation: "/invitation/:invitation_id",
  OrgList: "/organizations",

  ...createGroup("OrgNew", "/organizations/new", {
    Area: "*",
    Index: "/",
    GeneralInfo: "/general-info",
    ...createGroup("Teams", "/teams", {
      Area: "*",
      Index: "/",
      New: "/new",
      Edit: "/edit/:team_identifier",
    }),
    Done: "/:org_slug/done",
  }),

  ...createGroup("Org", "/organizations/:org_slug", {
    Area: "*",
    Home: "/",
    ...createGroup("Members", "/members", {
      Area: "*",
      Index: "/?:filter",
      Invite: "/invite",
      EditInvitation: "/invitation/:invitation_id",
      Edit: "/edit/:username",
    }),
    ...createGroup("Teams", "/teams", {
      Area: "*",
      Index: "/",
      New: "/new",
      Edit: "/edit/:team_identifier",
    }),
    Settings: "/settings",
    Plans: "/plans",
    Billing: "/billing",

    App: "/application/:app_slug",
  }),
});
